import { render, staticRenderFns } from "./JobDescDial.vue?vue&type=template&id=83887a48"
import script from "./JobDescDial.vue?vue&type=script&lang=js"
export * from "./JobDescDial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports